<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3 2a1 1 0 00-1 1v18a1 1 0 001 1h10a1 1 0 001-1v-4a1 1 0 10-2 0v3H4V4h8v3a1 1 0 102 0V3a1 1 0 00-1-1H3zm15.707 6.293a1 1 0 10-1.414 1.414L18.586 11H9a1 1 0 100 2h9.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3z"/></svg>